exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.consulta-instalaciones-conecta__base .estilo-grilla,\n#gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.ag-theme-material .ag-details-row {\n  padding: 17px !important;\n  background: #fafafa !important;\n}\n.ag-theme-material .ag-details-row .ag-details-grid {\n  border: 1px solid #ebebeb !important;\n}\n", ""]);

// exports
